import * as React from "react";
import { toastr } from "react-redux-toastr";
import { cloneDeep } from "lodash";
import VisualSearchService from "src/share/services/visualSearch";
import { initialVisualSearchState, VisualSearchActions } from "src/share/types/visualSearch";
import visualSearchReducer from "../state/reducer";

export const useTinEye = () => {
  const [state, dispatch] = React.useReducer(visualSearchReducer, cloneDeep(initialVisualSearchState));
  async function fetchImages(image, by) {
    try {
      dispatch({ type: VisualSearchActions.setFetchingData });
      const { data: { payload: { results, total, offset } } } = await VisualSearchService.tinEyeSearch(image, state.offset, by);
      dispatch({ type: VisualSearchActions.addImages, payload: { results, total, offset } });
    } catch (err) {
      dispatch({ type: VisualSearchActions.error, payload: "The given image couldn't be processed." });
      toastr.error("Error", "The given image couldn't be processed");
    }
  }
  return {
    state,
    actions: { dispatch, fetchImages }
  };
};



// WEBPACK FOOTER //
// ./src/modules/AdHocTools/VisualSearch/hooks/useTinEye.ts